import {Injectable, Injector} from "@angular/core";
import {CleverreportStoreState} from "../cleverreport.store.module";
import {Store} from "@ngrx/store";
import {ContactEntity, contactType} from "./contact.entity";
import {ContactActions} from "./contact.actions";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {Observable} from "rxjs/Observable";
import {BaseService} from "../base.service";
import {GlobalProvider} from "../../providers/global/global";

@Injectable()
export class ContactService extends BaseService {

  private databaseProvider;

  constructor(private store: Store<CleverreportStoreState>, private injector: Injector, protected globalProvider: GlobalProvider) {
    super(globalProvider);
    setTimeout(() => {
      this.databaseProvider = injector.get(DataProvider);
    })
  }

  addAll(contacts: Array<ContactEntity>, synced: boolean = true): void {
    if (!synced) {
      for (let contact of contacts) {
        if (!contact.hasOwnProperty('_id')) {
          this.databaseProvider.createDocumentWithoutInit(contact)
            .then((contact: ContactEntity) => {
              this.store.dispatch(ContactActions.add(contact));
            });
        }
      }
    } else {
      this.store.dispatch(ContactActions.addAll(contacts));
    }
  }

  add(contact: ContactEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.createDocumentWithoutInit(contact)
        .then((contact: ContactEntity) => {
          this.store.dispatch(ContactActions.add(contact));
        });
    }
    else {
      this.store.dispatch(ContactActions.add(contact));
    }
  }

  set(contact: ContactEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.updateDocument(contact)
        .then((contact: ContactEntity) => {
          this.store.dispatch(ContactActions.set(contact));
        });
    }
    else {
      this.store.dispatch(ContactActions.set(contact));
    }
  }

  remove(contact: ContactEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.softDeleteDocument(contact)
        .then(() => {
          this.store.dispatch(ContactActions.remove(contact._id));
        });
    } else {
      this.store.dispatch(ContactActions.remove(contact._id));
    }
  }

  getAllCustomers(): Observable<Array<ContactEntity>> {
    return this.getAll().map((contacts: Array<ContactEntity>) => {
      return contacts
        .filter((contact: ContactEntity) => {
          return contact.type === contactType.CUSTOMER;
        });
    });
  }

  getAllContractors(): Observable<Array<ContactEntity>> {
    return this.getAll().map((contacts: Array<ContactEntity>) => {
      return contacts
        .filter((contact: ContactEntity) => {
          return contact.type === contactType.CONTRACTOR;
        });
    });
  }

  getById(id: string): Observable<ContactEntity> {
    return this.getAll().map((contacts: Array<ContactEntity>) => {
      return contacts.find((contact: ContactEntity) => {
        return contact._id === id;
      });
    });
  }

  getByIds(ids: Array<string>): Observable<Array<ContactEntity>> {
    return this.getAll()
      .map((contacts: Array<ContactEntity>) => {
        return contacts.filter((contact: ContactEntity) => {
          return ids.indexOf(contact._id) !== -1;
        })
      })
  }

  getAllByType(type: contactType): Observable<Array<ContactEntity>> {
    return this.getAll()
      .map((contacts: Array<ContactEntity>) => {
        return contacts
          .filter((contact: ContactEntity) => {
            return contact.type === type;
          });
      });
  }

  public getAll(): Observable<Array<ContactEntity>> {
    return this.store.select('contacts').map((contacts: Array<ContactEntity>) => {
      return contacts
        .filter((contact) => {
          return !contact.hasOwnProperty('_deleted') && !contact.hasOwnProperty('deleted');
        })
    })
  }

  public convertToUserDocument(doc: any): any {
    return super.convertToUserDocument(doc);
  }

}



// WEBPACK FOOTER //
// ./src/store/contact/contact.service.ts